/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { internal_handlers_portfolio_BatchChildInput } from './internal_handlers_portfolio_BatchChildInput';
import type { internal_handlers_portfolio_EntryRatingInput } from './internal_handlers_portfolio_EntryRatingInput';
export type portfolio_BatchCreatePortfolioEntriesRequest = {
    childcare_id: string;
    children: Array<internal_handlers_portfolio_BatchChildInput>;
    /**
     * ClientCaptureID is an OPTIONAL server-side idempotency key (issue #1102).
     *
     * BATCH CAPTURE IS ONE SERVER-SIDE TRANSACTION, so the key applies to the
     * batch AS A UNIT, not per child: one key covers all N entries and their
     * shared group_capture_id. A replay returns the original batch — same
     * entries, same group_capture_id, same 201 — and writes nothing.
     *
     * UNIQUENESS IS PER ORGANISATION, not per author: the ledger is keyed on
     * (org_id, client_capture_id). A replay by the SAME author returns the
     * original; the same key presented by a DIFFERENT employee of that
     * organisation answers 409 PORTFOLIO_CAPTURE_KEY_CONFLICT and never that
     * author's draft, because a client-supplied key is attacker-controllable and
     * a draft is private to the employee who wrote it.
     */
    client_capture_id?: string;
    domain_ids?: Array<string>;
    observed_at: string;
    ratings?: Array<internal_handlers_portfolio_EntryRatingInput>;
    source?: portfolio_BatchCreatePortfolioEntriesRequest.source;
    status?: portfolio_BatchCreatePortfolioEntriesRequest.status;
    /**
     * SubjectChildIDs are children who APPEAR in this capture (e.g. everyone in
     * the shared photo), applied to EVERY entry in the batch in addition to that
     * entry's own primary child. Mirrors CreatePortfolioEntryRequest.SubjectChildIDs.
     *
     * The shared group_capture_id is a proxy, not the fact: a group EVENT captures
     * five children who are not all in one photo, a group PHOTO does. Subject rows
     * cannot be reconstructed later, so they are written at capture time.
     */
    subject_child_ids?: Array<string>;
    template_id?: string;
};
export namespace portfolio_BatchCreatePortfolioEntriesRequest {
    export enum source {
        MANUAL = 'manual',
        VOICE = 'voice',
        GROUP = 'group',
    }
    export enum status {
        DRAFT = 'draft',
        DOCUMENTED = 'documented',
    }
}

